import { NavLink, useNavigate, useParams } from "react-router";
import { ReactNode, useCallback, useState } from "react";
import t from "@/lang/lang";
import {
  MilestonePage,
  MilestonePageContent,
  MilestonePageHeader,
  MilestonePageTitle,
} from "@/shared/bsm/core/milestone/components/ui/milestone-page";
import {
  BreadcrumbItem,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/shared/components/ui/breadcrumb";
import { useProcessesProcessShowQuery } from "@/services/backend/processes/api/process-api";
import { ListRequest } from "@/services/backend/omni/offer/api/offer-api";
import { OfferSetupDropdown } from "@/services/backend/omni/offer/components/offer-setup-dropdown";
import { omniOfferSetupDropdownConfig } from "@/services/backend/omni/servicekindrules/omni-offer-setup-dropdown-config";
import {
  OfferTable,
  OfferTableFilters,
} from "@/services/backend/omni/offer/components/offer-table";
import { ProcessPageMainTemplate } from "@/routes/processes/[processId]/_components/process-page-main-template";
import { OmniBreadcrumbs } from "../../_components/omni-breadcrumbs";

export function OfferIndexPage() {
  const { processId } = useParams();
  const navigate = useNavigate();
  const { data: process } = useProcessesProcessShowQuery({ id: processId! });
  const [request, setRequest] = useState<ListRequest>({
    process: { active: true, values: [processId!] },
    customer: { active: false, values: [] },
    state: { active: false, values: [] },
    orderBy: [{ field: "date" }],
    limit: 50,
    offset: 0,
  });

  const renderRowLink = useCallback(
    (id: string, children: ReactNode) => <NavLink to={id}>{children}</NavLink>,
    [],
  );

  if (!process) return null;

  const breadcrumbs = (
    <OmniBreadcrumbs customerId={process.customerId} processId={process.id}>
      <BreadcrumbSeparator />
      <BreadcrumbItem>
        <BreadcrumbPage>{t("Angebote")}</BreadcrumbPage>
      </BreadcrumbItem>
    </OmniBreadcrumbs>
  );

  return (
    <ProcessPageMainTemplate breadcrumbs={breadcrumbs}>
      <MilestonePage>
        <MilestonePageHeader>
          <MilestonePageTitle>{t("Angebote")}</MilestonePageTitle>
        </MilestonePageHeader>
        <MilestonePageContent>
          <div className="grid gap-2">
            <div className="flex justify-between">
              <OfferTableFilters
                request={request}
                onRequestChange={setRequest}
              />
              <OfferSetupDropdown
                processId={process.id}
                config={omniOfferSetupDropdownConfig}
                onCreated={(id) => navigate(id)}
              />
            </div>
            <OfferTable
              request={request}
              onRequestChange={setRequest}
              renderRowLink={renderRowLink}
              showServiceKind
            />
          </div>
        </MilestonePageContent>
      </MilestonePage>
    </ProcessPageMainTemplate>
  );
}
